import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import BranchWarningBanner from '../../components/BranchWarningBanner/BranchWarningBanner';
import { refreshCurrentBranchStatus } from 'src/utils/branchStatus';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const controlToken = () => {
      const expired = localStorage.getItem('expired');
      const currentTime = Math.floor(Date.now() / 1000);
      const timeWithOffset = currentTime + 20 * 60;

      if (expired && parseInt(expired) > timeWithOffset) {
        return;
      } else {
        navigate('/login');
      }
    };
    controlToken();
  }, [navigate]);

  useEffect(() => {
    // Sekme yenilendiğinde veya token ile otomatik giriş yapıldığında
    // (login formu üzerinden geçmeden) mağazanın uyarı/blokaj durumunu tazele.
    refreshCurrentBranchStatus();
  }, []);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <BranchWarningBanner />
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
